import { useEffect, useRef } from 'react';

function useInputFocus() {
	const inputRef = useRef<HTMLInputElement | null>(null);

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.focus();
			if ('ontouchstart' in window) {
				inputRef.current.click();
			}
		}
	}, [inputRef]);

	return inputRef;
}

export default useInputFocus;
